import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '@/lib/api';
import { Trophy, Star } from '@phosphor-icons/react';

import { bubbleImageSrc } from '@/lib/bubbleImage';
const HallOfFame = () => {
  const [memorials, setMemorials] = useState([]);
  const [recent, setRecent] = useState([]);

  useEffect(() => {
    api.get('/hall-of-fame').then(({ data }) => setMemorials(data.hall));
    api.get('/memorials').then(({ data }) => setRecent(data.memorials));
  }, []);

  const Card = ({ m, rank }) => (
    <Link to={`/memorial/${m.bubble_id}`} className="glass rounded-2xl p-5 flex flex-col items-center hover:bg-white/5 transition" data-testid={`hof-${m.bubble_id}`}>
      {rank !== undefined && (
        <div className="font-display text-2xl font-black mb-2">
          {rank === 0 ? '👑' : rank === 1 ? '🥈' : rank === 2 ? '🥉' : `#${rank + 1}`}
        </div>
      )}
      <div className="relative h-32 w-32">
        <div className={`absolute inset-0 rounded-full blur-2xl opacity-50 bg-rar-${m.rarity || 'common'}`} />
        {bubbleImageSrc(m) ? (
          <img src={bubbleImageSrc(m)} alt={m.name} className="relative h-full w-full rounded-full object-cover ring-1 ring-white/10" style={{ filter: 'grayscale(0.5) brightness(0.85)' }} />
        ) : (
          <div className={`relative h-full w-full rounded-full bg-rar-${m.rarity || 'common'}`} />
        )}
      </div>
      <h3 className="font-display text-lg font-black mt-3 text-center">{m.name}</h3>
      <div className={`text-[10px] uppercase tracking-widest rar-${m.rarity}`}>{m.rarity} · {m.bubble_class}</div>
      <div className="mt-2 text-sm text-bx-cyan font-bold">{m.unique_holders} holders · {m.transfers} passes</div>
      {m.last_words && (
        <div className="text-xs italic text-white/55 mt-2 text-center">"{m.last_words}"</div>
      )}
    </Link>
  );

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-8 py-10 pb-24">
      <div className="text-center mb-10">
        <Trophy size={36} weight="duotone" className="text-bx-gold mx-auto" />
        <h1 className="font-display text-4xl sm:text-6xl font-black tracking-tighter mt-2">
          Hall of <span className="shimmer-text">Fame</span>
        </h1>
        <p className="text-white/65 mt-2 max-w-2xl mx-auto">
          The bubbles that became legends. Every one of them lived, traveled, and burst into stars.
        </p>
      </div>

      {memorials.length === 0 ? (
        <div className="glass rounded-2xl p-10 text-center text-white/65">
          <Star size={32} weight="duotone" className="mx-auto text-bx-volt" />
          <p className="mt-3 text-sm">The Hall is still being written. Every bubble has a journey — and an ending.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {memorials.map((m, i) => <Card key={m.bubble_id} m={m} rank={i} />)}
        </div>
      )}

      {recent.length > 0 && (
        <section className="mt-16">
          <h2 className="font-display text-2xl font-bold mb-4">Recently passed on</h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
            {recent.map((m) => <Card key={m.bubble_id} m={m} />)}
          </div>
        </section>
      )}
    </div>
  );
};

export default HallOfFame;
